/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import { Box, Grid, makeStyles } from "@material-ui/core"
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend } from "chart.js"
import InputsGroup from "./InputsGroup"
import { useEffect, useState } from "react"
import { getBillsByPCGElementsRequest, getBillsByPCGElementsTwoRequest, getBillsByPCGeneralRequest, getBillsByPCGeneralSelectedItemRequest, getBillsByPCGeneralSelectedItemRequestReset, getBillsByPCGeneralSpendByPeriodResourceReset, getBillsByPCGeneralSpendResourceByPeriodDetailsRequest, getBillsByPCGeneralSpendResourceRequest, getBillsByPCGeneralSpendResourceReset, getBuyOrderChangeRequest, getBuyOrderDataRequest, getBuyOrderDetailsOrderRequest, getBuyOrderDetailsRequest, getProjetsByCompanyRequest, resetBillsByPCGeneral, resetElements, resetElementsTwo, resetProjetsByCompanyRequest } from "../../actions/logistic-indicators.action"
import { useDispatch, useSelector } from "react-redux"
import BudgetChart from "./BudgetChart"
import MultiTypeChart from "./MultiTypeChart"
import { usePCFilters } from "../../hooks/useLocalStorageFilters"
import FilterableDataGridModal from "../../components/FilterableDataGridModal"
import BuyOrderModal from "./BuyOderModal"

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend)

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(3),
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
    },
    paper: {
        padding: theme.spacing(2),
        height: 300,
    },
    title: {
        fontSize: "0.9rem",
        color: "#1976d2",
        marginBottom: theme.spacing(1),
    },
    chartContainer: {
        height: "calc(100% - 40px)",
    },
}))


let elementsRequest = () => {};
let elementsDoubleClick = () => {};
let secondsElementsDoubleClickAction = (data) => {console.log(data)};

export default function GeneralPC() {
  const classes = useStyles()
  const dispatch = useDispatch();
  const logisticIndicators = useSelector((state) => state.logisticIndicators);
  
  const { filters, updateFilter } = usePCFilters({
    selectedCoin: "PEN",
    selectedCompany: "",
    mode: "-1",
    endDate: `31/12/${new Date().getFullYear()}`,
    period: "0",
    selectedProject: '',
    billsByPCLevel: "1",
    spendLevel: "1",
    selectedPCItem: '',
    selectedPCItemPeriod: '2',
    selectedPCSpenItem: '',
    chartType: 'barra',
  });

  const {
    selectedCoin,
    selectedCompany,
    mode,
    endDate,
    period,
    selectedProject,
    billsByPCLevel,
    spendLevel,
    selectedPCItem,
    selectedPCItemPeriod,
    selectedPCSpenItem,
    chartType,
  } = filters;

  const setSelectedCoin = (value) => updateFilter('selectedCoin', value);
  const setSelectedCompany = (value) => updateFilter('selectedCompany', value);
  const setMode = (value) => updateFilter('mode', value);
  const setEndDate = (value) => updateFilter('endDate', value);
  const setPeriod = (value) => updateFilter('period', value);
  const setSelectedProject = (value) => updateFilter('selectedProject', value);
  const setBillsByPCLevel = (value) => updateFilter('billsByPCLevel', value);
  const setSpendLevel = (value) => updateFilter('spendLevel', value);
  const setSelectedPCItem = (value) => updateFilter('selectedPCItem', value);
  const setSelectedPCItemPeriod = (value) => updateFilter('selectedPCItemPeriod', value);
  const setSelectedPCSpenItem = (value) => updateFilter('selectedPCSpenItem', value);
  const setChartType = (value) => updateFilter('chartType', value);
  
  const [selectedIndicatorTitle, setSelectedIndicatorTitle] = useState()
  const [selectedItem, setSelectedItem] = useState()
  const [selectedItemColumns, setSelectedItemColumns] = useState([])
  const [selectedItemColumnsTwo, setSelectedItemColumnsTwo] = useState([])
  const [secondsElementsData, setSecondsElementsData] = useState()
  const [searchText, setSearchText] = useState('');
  const [searchTextTwo, setSearchTextTwo] = useState('');
  const [buyOrderData, setBuyOrderData] = useState()

  const startDate = `01/05/2020`;

  useEffect(() => {
    console.log('selectedCompany', selectedCompany)
    // if (!selectedCompany) {
    //   return
    // }
    // updateFilter('selectedProject', '');
    dispatch(resetProjetsByCompanyRequest());
    getProjetsByCompanyRequest(selectedCompany, startDate, endDate);
  }, [selectedCompany, endDate])

  useEffect(() => {
    // if (!selectedCompany) {
    //   return      
    // }
    dispatch(resetBillsByPCGeneral());
    updateFilter('selectedPCItem', '');
    getBillsByPCGeneralRequest(selectedProject, billsByPCLevel, endDate);
  }, [selectedProject, endDate, billsByPCLevel, selectedCompany])

  useEffect(() => {
    if (!logisticIndicators.billsByPCGeneral.length || selectedPCItem) {
      return      
    }
    setSelectedPCItem(logisticIndicators.billsByPCGeneral[0].id);
  }, [logisticIndicators.billsByPCGeneral])

  useEffect(() => {
    if (!selectedPCItem) {
      return      
    }
    dispatch(getBillsByPCGeneralSelectedItemRequestReset());
    getBillsByPCGeneralSelectedItemRequest(selectedProject, selectedPCItem, endDate, selectedPCItemPeriod);
  }, [selectedPCItem, selectedProject, endDate, billsByPCLevel, selectedPCItemPeriod])

  useEffect(() => {
    if (!selectedPCItem) {
      return      
    }
    dispatch(getBillsByPCGeneralSpendResourceReset());
    updateFilter('selectedPCSpenItem', '');
    getBillsByPCGeneralSpendResourceRequest(selectedProject, selectedPCItem, spendLevel, endDate);
  }, [selectedPCItem, selectedProject, endDate, spendLevel])

  useEffect(() => {
    if (!logisticIndicators.billsByPCGeneralSpend.length || selectedPCSpenItem) {
      return      
    }
    setSelectedPCSpenItem(logisticIndicators.billsByPCGeneralSpend[0].id);
  }, [logisticIndicators.billsByPCGeneralSpend])
  
  useEffect(() => {
    if (!selectedPCItem || !selectedPCSpenItem) {
      return      
    }
    dispatch(getBillsByPCGeneralSpendByPeriodResourceReset());
    getBillsByPCGeneralSpendResourceByPeriodDetailsRequest(selectedProject, selectedPCItem, selectedPCSpenItem, selectedPCItemPeriod, endDate);
  }, [selectedPCSpenItem, selectedPCItemPeriod, selectedProject, endDate, selectedPCItem])

  const selectedBillPCItem = logisticIndicators.billsByPCGeneral.find(i => i.id === selectedPCItem);
  
  const elementsByPCDoubleClick = (item, isBill) => {
    console.log('item', item)
    const titlePrefix = isBill ? 'Total Gasto de partida' : 'Recurso por partida';
    const titleSufix = `: ${item.description} (${selectedCoin === 'PEN' ? item.CostoPEN : item.CostoUSD})`;
    setSelectedIndicatorTitle(`${titlePrefix}${titleSufix}`);
    setSelectedItem(item);
    elementsRequest = ({page, searchText}) => {
      dispatch(resetElements());
      getBillsByPCGElementsRequest(
        searchText,
        selectedProject,
        isBill && item.id ? item.id : (selectedPCItem || ''),
        !isBill && item.id ? item.id : '',
        endDate,
        page
      )
    }
    
    elementsDoubleClick = ({data, page= 1, searchText}) => {
      console.log(data)
      dispatch(resetElementsTwo());
      setSecondsElementsData({
        ...data,
        title: data.Descripcion
      });
      
      setSelectedItemColumnsTwo([
        {
          filterType: 'text',
          headerName: 'Código',
          field: 'CodOrden',
        },
        {
          filterType: 'text',
          headerName: 'Empresa',
          field: 'Empresa',
        },
        {
          filterType: 'text',
          headerName: 'Centro Compra',
          field: 'CentroCompra',
        },
        {
          filterType: 'text',
          headerName: 'Proyecto',
          field: 'Proyecto',
        },
        {
          filterType: 'text',
          headerName: 'Proveedor',
          field: 'Proveedor',
        },
        {
          filterType: 'text',
          headerName: 'Moneda',
          field: 'Moneda',
        },
        {
          filterType: 'text',
          headerName: 'Estado',
          field: 'Estado',
        },
        {
          filterType: 'text',
          headerName: 'Fecha',
          field: 'Fecha',
        },
        {
          filterType: 'text',
          headerName: 'Insumo',
          field: 'Insumo',
        },
        {
          filterType: 'number',
          headerName: 'Costo',
          field: selectedCoin === 'PEN' ? 'CostoPEN' : 'CostoUSD',
        },
      ])
      getBillsByPCGElementsTwoRequest(
        searchText, 
        selectedProject, 
        selectedPCItem || selectedItem?.id || '', 
        data.id, 
        endDate, 
        page
      )
    };

    secondsElementsDoubleClickAction = handleBuyOrderData

    elementsRequest({page: 1})
    setSelectedItemColumns([
      {
        filterType: 'text',
        headerName: 'Código',
        field: 'CodInsumo',
      },
      {
        filterType: 'text',
        headerName: 'Descripción',
        field: 'Descripcion',
      },
      {
        filterType: 'text',
        headerName: 'Unidad',
        field: 'Unidad',
      },
      {
        filterType: 'number',
        headerName: 'Cantidad',
        field: 'Cantidad',
      },
      {
        filterType: 'number',
        headerName: 'Costo PEN',
        field: 'CostoPEN',
      },
      {
        filterType: 'number',
        headerName: 'Costo USD',
        field: 'CostoUSD',
      },
    ])
  }

  const handleBuyOrderData = (data) => {
    console.log(data)
    setBuyOrderData(data)
    getBuyOrderDataRequest(data.id);
    getBuyOrderChangeRequest(startDate, selectedCoin);
    getBuyOrderDetailsRequest(data.id)
    getBuyOrderDetailsOrderRequest(data.id)
  }

  return (
    <Box className={classes.root}>
      <InputsGroup
        allowCompanyAll={true}
        allowEmptyProject={true}
        selectedCoin={selectedCoin}
        setSelectedCoin={setSelectedCoin}
        selectedCompany={selectedCompany}
        setSelectedCompany={setSelectedCompany}
        mode={mode}
        setMode={setMode}
        endDate={endDate}
        setEndDate={setEndDate}
        period={period}
        setPeriod={setPeriod}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
      />
      <Grid container spacing={2} style={{marginBottom: '40px'}}>
        <Grid item xs={12} md={5}>
          <BudgetChart 
            title='Total Gasto de Partida'
            selectedCoin={selectedCoin}
            selectedStructure={billsByPCLevel}
            setSelectedStructure={setBillsByPCLevel}
            requiresStructure={false}
            itemsData={logisticIndicators.billsByPCGeneral}
            customStructure={[
              {Nivel: '1', Descripcion: 'Empresa'},
              {Nivel: '2', Descripcion: 'Costo directo o indirecto'},
              {Nivel: '3', Descripcion: 'Tipo partida'},
              {Nivel: '4', Descripcion: 'Partida de Control'},
            ]}
            handleRowDoubleClick={(item) => elementsByPCDoubleClick(item, true)}
            itemsPerPage={5}
            setSelectedRow={(id) => {
              if (!id) {
                return
              }
              setSelectedPCItem(id)
            }}
            selectedRow={selectedPCItem}
            mainColor='#8A2BE2'
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <MultiTypeChart
            chartType={chartType}
            setChartType={setChartType}
            title={'Total gasto de partida' + (selectedBillPCItem ? ` - ${selectedBillPCItem?.description}` : '')}
            setSelectedPeriod={setSelectedPCItemPeriod}
            selectedPeriod={selectedPCItemPeriod}
            data={logisticIndicators.billsByPCGeneralSelectedItem.map(i => ({
              date: i.Periodo,
              value: chartType === 'curvaS' 
                ? i[`Costo${selectedCoin}_Acumulado`] 
                : i[`Costo${selectedCoin}`]
            }))}
            mainColor='#fd7e14'
            handleRowDoubleClick={() => {
              if (!selectedPCItem) return
              elementsByPCDoubleClick(
                logisticIndicators.billsByPCGeneral.find(i => i.id === selectedPCItem),
                true,
              )}
            }
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <BudgetChart 
            title='Recursos por partida seleccionada'
            selectedCoin={selectedCoin}
            selectedStructure={spendLevel}
            setSelectedStructure={setSpendLevel}
            requiresStructure={false}
            itemsData={logisticIndicators.billsByPCGeneralSpend.map(i => ({
              ...i,
              SaldoPEN: i.CostoPEN,
              SaldoUSD: i.CostoUSD,
            }))}
            customStructure={[
              {Nivel: '1', Descripcion: 'Nivel 1'},
              {Nivel: '2', Descripcion: 'Nivel 2'},
              {Nivel: '3', Descripcion: 'Nivel 3'},
            ]}
            itemsPerPage={5}
            setSelectedRow={(id) => {
              if (!id) {
                return
              }
              setSelectedPCSpenItem(id)
            }}
            selectedRow={selectedPCSpenItem}
            mainColor='#007bff'
            handleRowDoubleClick={(item) => elementsByPCDoubleClick(item, false)}
          />
        </Grid>
        <Grid item xs={12} md={7}>
          <MultiTypeChart
            chartType={chartType}
            setChartType={setChartType}
            title={'Total gasto de recurso' + (selectedPCSpenItem ? ` - ${logisticIndicators.billsByPCGeneralSpend.find(i => i.id === selectedPCSpenItem)?.description}` : '')}
            setSelectedPeriod={setSelectedPCItemPeriod}
            selectedPeriod={selectedPCItemPeriod}
            data={logisticIndicators.billsByPCGeneralSpendByPeriod.map(i => ({
              date: i.Periodo,
              value: chartType === 'curvaS' 
                ? i[`Costo${selectedCoin}_Acumulado`] 
                : i[`Costo${selectedCoin}`]
            }))}
            handleRowDoubleClick={() => {
              if (!selectedPCSpenItem) return
              elementsByPCDoubleClick(
                logisticIndicators.billsByPCGeneralSpend.find(i => i.id === selectedPCSpenItem),
                false,
              )}
            }
            mainColor='#6c757d'
          />
        </Grid>
      </Grid>
      {selectedItem &&
        <FilterableDataGridModal
          onClose={() => {
            setSelectedItem(null);
            setSelectedIndicatorTitle(null)
          }}
          onRowDoubleClick={(data) => elementsDoubleClick({data})}
          open={true}
          title={`${selectedIndicatorTitle}`}
          columns={selectedItemColumns}
          rows={logisticIndicators.elements}
          onPageChange={elementsRequest}
          totalItems={logisticIndicators.elementsTotalItems}
          searchText={searchText}
          setSearchText={(searchText) => {
            setSearchText(searchText)
            elementsRequest({searchText, page: 1})
          }}
        />
      }
      {secondsElementsData &&
        <FilterableDataGridModal
          onClose={() => {
            setSecondsElementsData(null)
            // elementsDoubleClick = () => {};
          }}
          onRowDoubleClick={(data) => secondsElementsDoubleClickAction(data)}
          open={true}
          title={`${secondsElementsData?.Descripcion || secondsElementsData?.label}`}
          columns={selectedItemColumnsTwo}
          rows={logisticIndicators.elementsTwo}
          searchText={searchTextTwo}
          setSearchText={(searchText) => {
            setSearchTextTwo(searchText)
            elementsDoubleClick({data: secondsElementsData, searchText, page: 1})
          }}
        />
      }
      {buyOrderData && <BuyOrderModal
        open={true}
        title='Orden de compra'
        paramBuyOrderData={buyOrderData}
        onClose={() => {
          // secondsElementsDoubleClickAction = (data) => {console.log(data)};
          setBuyOrderData(undefined);
        }}
      />}
    </Box>
  )
}